import React from "react";
import "../../../Styles/section-tabs.scss";

export default function PageTabs({
  tabs = [],
  activeTab,
  onChange,
  ariaLabel = "Sections",
  className = "",
}) {
  const visibleTabs = tabs.filter((tab) => !tab.hidden);

  return (
    <div
      className={["new-section-tabs", className].filter(Boolean).join(" ")}
      role="tablist"
      aria-label={ariaLabel}
    >
      {visibleTabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`new-section-tabs__tab ${activeTab === tab.id ? "is-active" : ""}`}
          onClick={() => onChange?.(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
